import type { ContextCard } from './route-context';

export interface RouteContextCardsProps {
  cards: ContextCard[];
}

function confidenceText(confidence: string): string {
  return confidence.replaceAll('_', ' ');
}

export function RouteContextCards({ cards }: RouteContextCardsProps) {
  if (cards.length === 0) return null;
  return (
    <section className="route-context-cards" aria-label="Route context">
      {cards.map((card) => (
        <article className="route-context-card" data-kind={card.kind} key={card.kind}>
          <h3>{card.title}</h3>
          <p>{card.value}</p>
          {card.source ? <small>{card.source}{card.confidence ? ` · ${confidenceText(card.confidence)}` : ''}</small> : null}
        </article>
      ))}
    </section>
  );
}
